module.exports = __webpack_public_path__ + "static/media/logo-future-well-kids@2x.d3a429cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-future-well-kids@2x.png
// module id = 160
// module chunks = 0